import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CreateProduct, Variants, Attribute, ProductStateEnum } from './models/add-product.model';
import { environment } from '@env/environment';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { category } from '@app/help-support/request-call-back/category-list';

// import FMCG from '@app/FMCG-schema';

@Injectable({
  providedIn: 'root'
})
export class AddProductService {
  categoryString$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  primaryColor$: BehaviorSubject<[]> = new BehaviorSubject<[]>([]);
  // private payload: CreateProduct = {} as any;
  payload$: BehaviorSubject<CreateProduct> = new BehaviorSubject<CreateProduct>({} as any);

  private productTypeChange = new Subject<any>();
  productTypeChange$ = this.productTypeChange.asObservable();

  private messageSource = new BehaviorSubject<any>(null);
  variantInfoAttr = this.messageSource.asObservable();
  finalPayload: CreateProduct = {} as any;
  public relativeCategoryPath: string;
  public totalAttributes: number;
  public variationThemeId: string;
  private variantAttributesMaster: Array<Attribute>;
  private productAttributesMaster: Array<Attribute>;
  private _productState: string
  private _schema: any

  public relativeCat: {
    schemaName: any,
    productType: any,
    category: string,
    subCategory: string,
    type: string,
    subType: string,
    l1NumericID : string,
    l2NumericID : string,
    l3NumericID : string,
    l4NumericID : string,
  };
  public backEditFlag: boolean = false;
  public currentStep: Number = 0;
  public productInfoFormDirtyStatus: boolean = false;
  public dailogOpen: boolean = false;
  public backwardCompatible: boolean = false;
  public atttributeType: any;
  public navigateToInventorySetting: boolean = false;
  public hsn: string = '';
  public gst: string = '';
  public schemaName: string;

  variationTheme1 = {};
  variantAttributesSchema;
  themeKnot;
  productAttributesSchema;
  dependentVariantAttributesSchema;
  hiddenVariantFields : any = [];
  measureList : any = [];
  keyChanged : boolean = false;
  superiorProductAttributes : any = [];
  categoryId;
  leafNumericID;
  productType;
  refreshImages : boolean = false;
  brandDetail$ = new BehaviorSubject([]);
  productKeyChanged$ = new BehaviorSubject(false);
  isApparelCategory= false
  apparelTheme = "size"
  schemaDetails$ = new BehaviorSubject(null);
  isRetentionCategory = false;
  sizeChart$ = new BehaviorSubject(null)
  availableSizes = []


  constructor(private httpClient: HttpClient) { }

  intilizePayload() {
    this.payload$ = new BehaviorSubject<CreateProduct>({} as any);
  }

  getCategoryName() {
    if (this.relativeCat) {
      console.log('this.relativeCat.category ===> ', this.relativeCat.category)
      switch (this.relativeCat.category) {
        case 'ecb85a9d-f017-476c-86c4-0ea2fdc3d99d': return 'FMCG';
        case '16abecae-91a8-4096-821f-e77d3703a020': return 'APPARELS';
        case '4abdf317-305e-464d-b800-b2490e085ce9': return 'HORECA';
        case 'a33571a6-5000-4901-8e1c-e8e308c3e6bd': return 'HOME_FURNISHING';
        case 'af07e2a8-f218-4697-bb0c-9f240c5bc1d3': return 'FOOTWEAR';
        case 'b0726a3e-388d-40ab-be53-6ac00e5e98f6': return this.getSchemaName();
        case '00c96728-87dd-42d2-95b4-8a5e2a08d43a' : return 'TOYS_AND_SPORTS';
        case 'edit': return 'EDIT_VARIANT';
        default: return 'APPARELS';
      }
    } else {
      this.setCurrentStep(null);
    }
  }
  emitVariantInfoAttr(message: any) {
    this.messageSource.next(message)
  }
  setSchemaNameOther(name) {
    this.schemaName = name;
  }

  getSchemaNameOther() {
    return this.schemaName;
  }

  getSchemaName() {
    switch (this.relativeCat.subCategory) {
      case '3aef2eb3-3c8a-4fad-a0c5-d5b46a21afa8': return 'MOBILE_ACCESSORIES';
      case 'b63076bb-09e0-4371-83e8-5b6f6af1b11d': return 'MOBILE';
      default: return 'MOBILE';
    }
  }

  fetchVariationThemeId() {
    // let categoryId = 'ecb85a9d-f017-476c-86c4-0ea2fdc3d99d' // FMCG
    // let categoryId = '16abecae-91a8-4096-821f-e77d3703a020'// Apparels
    // let categoryId = '4abdf317-305e-464d-b800-b2490e085ce9'// HoreCa
    let id;
    if (this.relativeCat.category === 'b0726a3e-388d-40ab-be53-6ac00e5e98f6') {
      id = this.relativeCat.subCategory;
    }
    else if(this.relativeCat.category === '00c96728-87dd-42d2-95b4-8a5e2a08d43a'){
      id = this.relativeCat.type; //For toy category, send L3
    }
     else {
      id = this.relativeCat.category;
    }
    const url = environment.with_auth_url + '/productcategory/api/v1/variationthemes/category/' + id;
    return this.httpClient.get(url);
  }


  fetchCategorySchema() {
   // const category = this.getCategoryName();
    // const url = environment.with_auth_url + '/product-catalog/api/v1/schema?schemaName=' + category;
    //Responsible for fetching json schema form
    const url = environment.with_auth_url + '/product-catalog/api/v1/schema/' + this.relativeCat.subType + '?productType=UNIT';
    return this.httpClient.get(url);
  }

  fetchSchemaIdParam(id, type) {
    let url = environment.with_auth_url + '/product-catalog/api/v1/schema/' + id;
    if(type)
      {
        url = url + '?productType=' + type;
      }
    //+ '?productType=' + type
    return this.httpClient.get(url);
  }

  setAttributesLength(number) {
    this.totalAttributes = number;
  }

  getAttributesLength() {
    return this.totalAttributes;
  }

  setAttributesType(attributes) {
    this.atttributeType = attributes;
  }

  getAttributesType() {
    return this.atttributeType;
  }

  getLabelName(variant) {
    let atttributeTypes = this.getAttributesType();

    return variant.attributes
        .filter(attribute => atttributeTypes.includes(attribute.key))
        .map(label => label.value)
        .join(", ");
  }

  fetchCategorySchemaV2() {
    console.log(this.relativeCat);
    return this.relativeCat;
  }

  fetchVariationThemes(id) {
    this.variationThemeId = id;
    const serviceUrl = '/productcategory/api/v1/attributes?page=1&perPage=100&sortBy=id&variationThemeId=';
    const themeUrl = environment.with_auth_url + serviceUrl + id;
    return this.httpClient.get(themeUrl);
  }

  fetchProductAttributes() {
    const serviceUrl = '/productcategory/api/v1/attributes?page=1&perPage=100&sortBy=id&categoryId=';
    let prodAttrUrl;
    if (this.relativeCat.category === 'b0726a3e-388d-40ab-be53-6ac00e5e98f6') {
      prodAttrUrl = environment.with_auth_url + serviceUrl + this.relativeCat.subCategory;
    } else {
      prodAttrUrl = environment.with_auth_url + serviceUrl + this.relativeCat.category;
    }
    return this.httpClient.get(prodAttrUrl);
  }

  getVariantAttributesMaster() {
    return this.variantAttributesMaster;
  }

  getProductAttributesMaster(){
    return this.productAttributesMaster;
  }

  setProductAttributes(productAttributesList, variantAttributesList) {
    this.productAttributesMaster = productAttributesList;
    this.variantAttributesMaster = variantAttributesList;
    console.log("this.productAttributesMaster", this.productAttributesMaster);
    console.log("this.variantAttributesMaster ", this.variantAttributesMaster );
  }

  generateAttributeMapping(attributes, mapWith = 'product') {
    const attributeList: Attribute[] = [];
    let masterList: Attribute[];
    if (mapWith === 'product') {
      masterList = this.productAttributesMaster;
    } else {
      masterList = this.variantAttributesMaster;
    }
    masterList.forEach(attribute => {
      if (attributes.hasOwnProperty(attribute.key) && attribute.key !== 'stock') {
        const elem = {
          id: attribute.id,
          displayName: attribute.displayName,
          key: attribute.key,
          value: attributes[attribute.key]
        }
        attributeList.push(elem);
      }
    });
    return attributeList;
  }

  saveProductAttributes(productInfo, productAttrInfo) {
    console.log("save product attribute ::::>>>")
    if (productInfo.taxPercentage) {
      productInfo.taxPercentage /= 100;
    }
    const currentPayload = this.payload$.value;
    console.log(productInfo);
    const updatedPayload = { ...currentPayload, ...productInfo, ...this.relativeCat, attributes: productAttrInfo };
    let extraKeys = ['l1NumericID', 'l2NumericID', 'l3NumericID', 'l4NumericID'];
    extraKeys.forEach((el) => {
      if(updatedPayload[el]){
        delete updatedPayload[el];
      }
    });
    if (updatedPayload.subType === updatedPayload.type) {
      updatedPayload.subType = null;
    }
    updatedPayload.schemaName = this.getCategoryName();
    // if(this.getCategoryName() === 'FOOTWEAR'){
    //   updatedPayload.schemaName = this.getSchemaNameFromSchema();
    //   if(this.getVariationThemeKnot()){
    //     updatedPayload.variationThemeKnot = this.getVariationThemeKnot();
    //   }
    //   updatedPayload.leafNodeId = this.fetchLeafCategoryNumericID();
    // }
    console.log(updatedPayload);
    console.log(this.payload$);
    this.payload$.next({...updatedPayload});
    this.productTypeChange.next({...updatedPayload});

  }

  saveVariantAttributes(variantsInfo,combinationAttribute=[]) {
    console.log("save variation Attribute ;;;;>> ")
    // const variantAttributesList = this.variantAttributesMaster;
    // const variantAttributesData = [];
    // variantAttributesList.forEach(attribute => {
    //   if (variantsInfo[0].hasOwnProperty(attribute.key)) {
    //     variantAttributesData.push({
    //       key: attribute.key,
    //       id: attribute.id,
    //       displayName: attribute.displayName
    //     });
    //   }
    // });
    const variants: Array<Variants> = [];
    const currentPayload = this.payload$.value;
    console.log("current payload from variants", currentPayload);
    let productType, materialType, isProductTypeAvailable : boolean = false, isMaterialAvailable : boolean = false;
    if(currentPayload?.attributes['productType'] && currentPayload?.attributes['productType']!==''){
      isProductTypeAvailable = true;
      productType = currentPayload?.attributes['productType'];
    }
    if(currentPayload?.attributes['material'] &&  currentPayload?.attributes['material'] !== ''){
      isMaterialAvailable = true;
      materialType = currentPayload?.attributes['material'];
    }
    variantsInfo.map((item, i) => {
      const variant = {} as any;
      let { skuId, label, id, ...attributes } = item;
      variant.skuId = skuId;
      variant.label = label;
      variant.attributes = attributes;
      variant.attributes.mrp = +variant.attributes.mrp;
      variant.attributes.moq = +variant.attributes.moq;
      if(this.getCategoryName() !== 'FOOTWEAR'){
        variant.attributes.stock = variant.attributes.stock ? variant.attributes.stock : '';
      }
      else{
        delete variant.attributes.stock;
      }
      variant.attributes.sellingPrice = +variant.attributes.sellingPrice;
      variant.attributes.productWeight = variant.attributes.productWeight;
      variant.id = id ? id : "";
      variant.isActive = true;
      variant.isDeleted = false;
      variant.isDefault = i === 0 ? true : false;
      variant.sellerId = sessionStorage.getItem('orgId');
      if(this.getVariationThemeKnot()){
        variant.variationThemeKnot = this.getVariationThemeKnot();
      }
      variant.leafNodeId = this.fetchLeafCategoryNumericID() || localStorage.getItem('leafNodeId');
      if(isProductTypeAvailable){
        variant.attributes.productType = productType;
      }
      if(this.getMeasureUOM().length > 0){
        variant.attributes.measureUOM = this.getMeasureUOM()[i];
      }
      if(isMaterialAvailable){
        variant.attributes.material = materialType;
      }
       if(combinationAttribute?.length>0) {
      variant.attributes = {...variant.attributes, ...combinationAttribute[i]}
       }
      variants.push(variant);
    });

    const updatedPayload = { ...currentPayload, variants };
    this.payload$.next(updatedPayload);
  }

  saveVariationThemes(theme) {
    console.log("save variation theme ::> ")
    const variants = theme.map(ele => {
      return ele.id
      // return {
      //   id: ele.id,
      // key: ele.key,
      // displayName: ele.displayName,
      // values: ele.metadata && ele.metadata.values ? ele.metadata.values : null
      // };
    });
    console.log(variants)
    const currentPayload = this.payload$.value;
    const updatedPayload = { ...currentPayload, variantAttributes: variants };
    this.payload$.next(updatedPayload);
  }

  saveVariationThemesOther(ids) {
    console.log("save variation theme other :::>>>")
    const currentPayload = this.payload$.value;
    const updatedPayload = { ...currentPayload, variantAttributes: ids };
    this.payload$.next(updatedPayload);
  }

  saveProductImages(product, variants) {
    console.log("save product theme ::::>>")
    const currentPayload = this.payload$.value;
    // currentPayload.variants.map()
    currentPayload.primaryImage = product[0];
    currentPayload.images = product.filter(value => value && value.length > 0);
    variants.forEach(variant => {
      variant.images = variant.images.filter(value => value && value.length > 0);
      variant.primaryImage = variant.images && variant.images[0] ? variant.images[0] : product[0];
      variant.images = variant.images && variant.images.length ? variant.images : currentPayload.images;
    });
    const updatedPayload = { ...currentPayload, variants };
    this.finalPayload = updatedPayload;
    localStorage.setItem('payload', JSON.stringify(this.finalPayload));
    this.payload$.next(updatedPayload);
  }

  getCreateProductPayload() {
    return this.payload$.asObservable();
  }

  intializeFinalPayload() {
    this.finalPayload = {} as any;
  }

  getFinalCreateProductPayload() {
    // return this.payload$.value;
    return this.finalPayload;
    // return JSON.parse(localStorage.getItem('payload'));
  }

  getFromMediaStore(imageKey) {
    const url = environment.without_auth_url + '/cmedia-store/files/' + imageKey;
    return url;
  }

  setCategory(category) {
    this.categoryString$.next(category);
  }

  getCategory() {
    return this.categoryString$.asObservable();
  }

  getCategoryValue() {
    return this.categoryString$.value;
  }

  setPrimaryColor(category) {
    this.primaryColor$.next(category);
  }

  getPrimaryColor() {
    return this.primaryColor$.asObservable();
  }

  setCategorySelection(relativeCategories) {
    console.log(relativeCategories)
    this.relativeCat = relativeCategories;
  }

  getCategorySelection() {
    return this.relativeCat ? this.relativeCat : null;
  }

  setRelativeCategoryPath(relativeCategoryPath) {
    this.relativeCategoryPath = relativeCategoryPath;
  }

  getRelativeCategoryPath() {
    return this.relativeCategoryPath ? this.relativeCategoryPath : null;
  }

  saveTheme1(theme1) {
    console.log(theme1)
    this.variationTheme1 = theme1;
  }

  getTheme1() {
    return this.variationTheme1;
  }

  saveProductAsPublished() {
    const payload = this.enhancePayload();
    const variantAttribute = this._schema?.properties?.variants?.items?.properties?.attributes?.properties
      ? Object.keys(this._schema.properties.variants.items.properties.attributes.properties)
      : [];
    if(this.getCategoryName() === 'HOME_FURNISHING' || this.getCategoryName() === 'TOYS_AND_SPORTS') {
      payload.schemaName = this.getSchemaNameOther();
    }
    if(this.getCategoryName() === 'FOOTWEAR'){
      delete payload["tags"]
      payload.schemaName = this.getSchemaNameFromSchema() ||  this.getSchemaNameOther();
      payload['variants']?.forEach(variant=>{
          let variantKeys = Object.keys(variant?.attributes)
          variantKeys.forEach(keys=>{
            if(variantAttribute.indexOf(keys) == -1) {
              delete variant["attributes"]?.[keys]
            }
          })
      })
      const productType = payload?.["attributes"]?.["productType"]
      if(payload["schemaName"] != "FOOTWEAR_SHOES_ACCESSORIES") {
        payload['variants']?.forEach(variant=>{
          delete variant?.["attributes"]?.["productType"]
        })
      }
      if(productType === 'Shoe Care Kit') {
        payload['variants']?.forEach(variant=>{
          delete variant?.["attributes"]?.["measureUOM"]
        })
      }
      payload['variants']?.forEach(variant=>{
        delete variant?.["undefined"]
      })
      delete payload["variantAttributes"]
      delete payload["variationThemeId"]
    }
    payload.productSource = 'SELLER';
    if(this.isRetentionCategory) {
      const variationThemeKnot ="color_size"
      const leafNodeId = this.fetchLeafCategoryNumericID() || this.getleafNumericId() || localStorage.getItem('leafNodeId');
      payload["variationThemeKnot"] = variationThemeKnot
      payload["leafNodeId"] = leafNodeId
      this.sizeChart$.subscribe(sizeChartKey=>{
        if(sizeChartKey) {
            payload.attributes['sizeChart'] = sizeChartKey
        }
    })
      delete payload["variantAttributes"]
      delete payload["variationThemeId"]
      payload.variants?.forEach(variant=>{
        delete variant['color']
        delete variant['size']
        variant["variationThemeKnot"] = variationThemeKnot
        variant["leafNodeId"] = leafNodeId
      })
    }
    if (payload['id']) {
      return this.httpClient.put(environment.with_auth_url + '/product-catalog/api/v3/products', payload);
    } else {
      return this.httpClient.post(environment.with_auth_url + '/product-catalog/api/v3/products', payload);
    }
  }

  saveProductAsDraft() {
    // const payload = this.enhancePayload('DRAFTED');
    // return this.httpClient.post(environment.with_auth_url + '/product-catalog/api/v3/products', payload);
    const payload = this.draftPayload();
    return this.httpClient.post(environment.with_auth_url + '/product-catalog/api/v3/products/draft', payload);
  }

  validateDuplicateSkuIds(body: any) {
    return this.httpClient.post(environment.with_auth_url + '/product-catalog/api/v3/products/validateDuplicateSkuIds', body);
  }

  draftTest() {
    console.log(this.payload$.value)
  }

  draftPayload() {
    const currentPayload = this.payload$.value;
    // const currentPayload = JSON.parse(localStorage.getItem('payload'));
    if (currentPayload.variants) {
      currentPayload.variationThemeId = this.variationThemeId;
    } else {
      currentPayload.variationThemeId = "";
    }
    currentPayload.isActive = true;
    currentPayload.isDeleted = false;
    currentPayload.state = 'DRAFTED';
    currentPayload.productSource = 'SELLER';
    currentPayload.sellerId = sessionStorage.getItem('orgId');
    if (currentPayload.variants) {
      currentPayload.variants.forEach(element => {
        delete element.label;
      });
    } else {
      currentPayload.variantAttributes = [];
    }
    currentPayload.primaryImage = currentPayload.primaryImage || "";
    currentPayload.images = currentPayload.images || [""];
    if(this.getCategoryName() === 'FOOTWEAR'){
      currentPayload.schemaName = this.getSchemaNameFromSchema();
      if(this.getVariationThemeKnot()){
        currentPayload.variationThemeKnot = this.getVariationThemeKnot();
        delete currentPayload.variationThemeId;
      }
      currentPayload.leafNodeId = this.fetchLeafCategoryNumericID() || localStorage.getItem('leafNodeId');
    }
    if(this.isRetentionCategory) {
      const variationThemeKnot ="color_size"
      const leafNodeId = this.fetchLeafCategoryNumericID() || this.getleafNumericId() || localStorage.getItem('leafNodeId');
      currentPayload["variationThemeKnot"] = variationThemeKnot
      currentPayload["leafNodeId"] = leafNodeId
      delete currentPayload["variantAttributes"]
      delete currentPayload["variationThemeId"]
      currentPayload.variants?.forEach(variant=>{
        delete variant['color']
        delete variant['size']
        variant["variationThemeKnot"] = variationThemeKnot
        variant["leafNodeId"] = leafNodeId
      })
    }
    this.sizeChart$.subscribe(sizeChartKey=>{
      if(sizeChartKey) {
        currentPayload.attributes['sizeChart'] = sizeChartKey
      }})

    return currentPayload;
  }

  private enhancePayload(state: ProductStateEnum = 'PUBLISHED') {
    const currentPayload = this.payload$.value;
    // Performing this step here for BE requirements for MDM :: images array shouldn't contain any primary image ID either at product level / variant level.
    if (currentPayload.images && Array.isArray(currentPayload.images)) {
      currentPayload.images = currentPayload.images.filter((img) => img && img!== currentPayload.primaryImage);
    }
    if (currentPayload.variants && Array.isArray(currentPayload.variants)) {
      currentPayload.variants.forEach((currVariant : any) => {
        if (currVariant.images && Array.isArray(currVariant.images)) {
          currVariant.images = currVariant.images.filter((variantImg) => variantImg && variantImg !== currVariant.primaryImage);
        }
        // Object.assign(currVariant.attributes, {
        //   'unitWeight' : '5',
        //   'unitWeightType' : 'Gms'
        // });
        if(this.getCategoryName() == "FOOTWEAR"){
          let result;
          console.log("currVariant", currVariant);
            Object.keys(currVariant?.attributes).forEach(key => {
              if (currVariant?.attributes[key] === null) {
                delete currVariant?.attributes[key];
              }
              if(key == 'length' || key == 'volume'){
                  let totalvalue = currVariant?.attributes[key];
                  result = totalvalue.split(' ')[1];
                  console.log("result", result);
                  currVariant.attributes['measureUOM'] = result;
              }
          });
        }
      });
    }
    // const currentPayload = JSON.parse(localStorage.getItem('payload'));
    currentPayload.variationThemeId = this.variationThemeId;
    currentPayload.schemaName = this.getCategoryName();
    currentPayload.isActive = true;
    currentPayload.isDeleted = false;
    currentPayload.state = state;
    currentPayload.productSource = 'SELLER';
    currentPayload.sellerId = sessionStorage.getItem('orgId');
    if (currentPayload.variants && Array.isArray(currentPayload.variants)) {
      currentPayload.variants.forEach(element => {
        delete element.label;
      });
    }
    if(this.getCategoryName() === 'FOOTWEAR'){
      currentPayload.schemaName = this.getSchemaNameFromSchema() || this.getSchemaNameOther();
      if(this.getVariationThemeKnot()){
        currentPayload.variationThemeKnot = this.getVariationThemeKnot();
      }
      currentPayload.leafNodeId = this.fetchLeafCategoryNumericID() ||  localStorage.getItem('leafNodeId');
      if(!currentPayload?.productType){
        currentPayload.productType = this.getproductTypeFromEdit();
      }
      delete currentPayload.variationThemeId;
      delete currentPayload?.subType;
    }
    return currentPayload;
  }

  getColorMapping() {
    return this.httpClient.get(environment.with_auth_url + '/seller/api/v1/product/color-map')
  }

  getProductDetails(productId) {
    return this.httpClient.get(environment.with_auth_url + '/seller/api/v1/product/review/product-detail?productId=' + productId + "&noStockAttribute=true")
  }

  // As per footwear category revamp, we'll call this end point for all categories for EDIT, CLONE flow.
  getMigratedProductDeatils(productId) {
    return this.httpClient.get(environment.with_auth_url + '/seller/api/v1/product/review/migrated/product-detail?noStockAttribute=true&productId='+productId);
  }

  getAllCategories() {
    return this.httpClient.get(environment.with_auth_url + '/seller/api/v1/category');
  }

  setBackEditFeatureFlag(flag) {
    this.backEditFlag = flag;
  }

  getBackEditFlag() {
    return this.backEditFlag;
  }

  setCurrentStep(step) {
    this.currentStep = step;
  }

  getCurrentStep() {
    return this.currentStep;
  }

  setFormDirtyStatus(status) {
    this.productInfoFormDirtyStatus = status;
  }

  getFormDirtyStatus() {
    return this.productInfoFormDirtyStatus;
  }

  setIsDialogOpen(state) {
    this.dailogOpen = state;
  }

  getIsDialogOpen() {
    return this.dailogOpen;
  }

  setBackWardCompatible(state) {
    this.backwardCompatible = state;
  }

  getBackWardCompatible() {
    return this.backwardCompatible;
  }

  setInventorySettingNavigation(flag) {
    this.navigateToInventorySetting = flag;
  }

  getInventorySettingNavigation() {
    return this.navigateToInventorySetting;
  }

  setHSNAndGST(hsn, gst) {
    this.hsn = hsn;
    this.gst = gst;
  }

  gstHSNAndGST() {
    return { hsn: this.hsn, gst: this.gst };
  }

  getThemeAttributes(productType, id, isAddFlow?){
    let numericId;
    if(isAddFlow){
      numericId = id  || this.fetchLeafCategoryNumericID();
    }
    else{
      numericId = id || localStorage.getItem('leafNodeId') || this.fetchLeafCategoryNumericID();
    }
    return this.httpClient.get(environment.with_auth_url + '/seller/api/v1/schema/getThemeConfig?numericId=' +numericId + '&productType=' +productType);
  }

  setVariantAttributesFromSchema(variantsList){
    this.variantAttributesSchema = variantsList;
  }

  getVariantAttributesFromSchema(){
    return this.variantAttributesSchema;
  }

  setproductAttributesFromSchema(productsList){
    this.productAttributesSchema = productsList;
  }

  getProductAttributesFromSchema(){
    return this.productAttributesSchema;
  }

  getDependentVariantAttributesFromSchema(){
    return this.dependentVariantAttributesSchema;
  }

  setDependentVariantAttributesFromSchema(list){
    this.dependentVariantAttributesSchema = list;
  }
  getSchemaNameFromSchema(){
    return this.relativeCat?.schemaName;
  }

  setVariationThemeKnot(themeknot){
    this.themeKnot = themeknot;
  }
  getVariationThemeKnot(){
    return this.themeKnot;
  }

  fetchLeafCategoryNumericID(){
    if(this.relativeCat?.l4NumericID && this.relativeCat?.l4NumericID!==''){
      return this.relativeCat?.l4NumericID;
    }
    else if(this.relativeCat?.l3NumericID && this.relativeCat?.l3NumericID!==''){
      return this.relativeCat?.l3NumericID;
    }
    else if(this.relativeCat?.l2NumericID && this.relativeCat?.l2NumericID!==''){
      return this.relativeCat?.l2NumericID;
    }
    else{
      return this.relativeCat?.l1NumericID;
    }
  }
  setHiddenVariantFields(list){
    this.hiddenVariantFields = list;
  }

  getHiddenVariantsList(){
    return this.hiddenVariantFields;
  }
  setMeasureUOM(list){
    this.measureList = list;
    console.log("this.measureList ", this.measureList );
  }
  getMeasureUOM(){
    return this.measureList;
  }

  setKeyChanged(key){
    this.keyChanged = key;
  }

  getKeyChanged(){
    return this.keyChanged;
  }

  setProductKeyChanged(key) {
    this.productKeyChanged$.next(key)
  }

  getProductKeyChanged() {
    return this.productKeyChanged$
  }

  setSuperiorProductAttributes(list){
    console.log("list from superior product types", list);
    this.superiorProductAttributes = [...list];
    console.log(" this.superiorProductAttributes",  this.superiorProductAttributes);
  }

  getSuperiorProductAttributes(){
    return this.superiorProductAttributes;
  }

  setCategoryFromEdit(category){
    this.categoryId = category;
  }

  getCategoryFromEdit(){
    return this.categoryId;
  }

  setLeafNumericIdFromEdit(id){
    this.leafNumericID = id;
    localStorage.setItem('leafNodeId', this.leafNumericID);
  }

  getleafNumericId(){
    return this.leafNumericID;
  }

  removeLeafNumericId(){
    localStorage.removeItem('leafNodeId');
    this.leafNumericID = "";
  }

  setProductTypeFromEdit(productType){
    this.productType = productType;
  }

  getproductTypeFromEdit(){
    return this.productType;
  }

  setRefreshImages(flag){
    this.refreshImages = flag;
  }

  getRefreshImages(){
    return this.refreshImages;
  }

  fetchBrandDetail() {
    const leafNodeId = this.fetchLeafCategoryNumericID() || localStorage.getItem('leafNodeId');
    const url =environment.with_auth_url +
    '/seller/api/v1/product/approvedBrands?leafNodeId='+leafNodeId;
    return this.httpClient.get(url);
  }

  setBrandDetail(brandList) {
    this.brandDetail$.next(brandList);
  }

  getBrandDetail() {
    return this.brandDetail$;
  }

  setState(state) {
    this._productState = state
  }

  getState() {
    return this._productState
  }

  setSchema(schema) {
    this._schema = schema
  }

  getSchema() {
    return this._schema
  }

}
